import _isEmpty from "lodash/isEmpty";
import { Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { withStyles } from "@mui/styles";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

import { styles } from "../styles";
import { theme } from "../../../config/theme";
import loader from "../../../images/loader-dots.svg";
import { getUptimeMetrics } from "../../../api/metrics/index";
import { getDefaultBeforeDate } from "../../../helpers/metrics";

const CurrentStatusCard = ({ classes }) => {
  const [currentDataState, setCurrentDataState] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchCurrentMetrics();
  }, []);

  const fetchCurrentMetrics = async () => {
    const currentData = await getUptimeMetrics({
      startTime: new Date(getDefaultBeforeDate()),
      endTime: new Date(Date.now())
    });

    const currentDataState = currentData.map((data) => {
      const { name, value } = data[0];
      return {
        name,
        value,
        color: value ? theme.palette.chart.green : theme.palette.chart.red
      };
    });

    setCurrentDataState(currentDataState);
    setIsLoading(false);
  };

  if (_isEmpty(currentDataState) && !isLoading) {
    return null;
  }

  return (
    <div className={classes.cardWrapper}>
      {isLoading ? (
        <img alt="loader" src={loader} style={{ width: 50, margin: "0 47%" }} />
      ) : (
        <>
          <div className={classes.headerWrapper}>
            <Typography className={classes.primaryHeading}>Current Status</Typography>
          </div>
          <>
            {currentDataState.map((item, index) => (
              <div className={classes.itemWrapper} key={index}>
                <FiberManualRecordIcon style={{ color: `${item.color}`, width: 14 }} />
                <div className={classes.nameWrapper}>{item.name}</div>
              </div>
            ))}
          </>
        </>
      )}
    </div>
  );
};

export default withStyles(styles)(CurrentStatusCard);
